// VeriLink - Trusted News & Research Sources Whitelist
// Domains in this list bypass source-reputation penalties in article credibility scoring.
// The publication itself is treated as the source of record.

export const TRUSTED_NEWS_DOMAINS = [
  // Wire services & top international news
  'reuters.com',
  'apnews.com',
  'bbc.com',
  'bbc.co.uk',
  'aljazeera.com',
  'dw.com',

  // Major newspapers (US/UK/AU/CA)
  'nytimes.com',
  'washingtonpost.com',
  'wsj.com',
  'theguardian.com',
  'ft.com',
  'theatlantic.com',
  'economist.com',
  'latimes.com',
  'usatoday.com',
  'bloomberg.com',
  'cbc.ca',
  'abc.net.au',
  'smh.com.au',

  // Public broadcasters
  'npr.org',
  'pbs.org',

  // Tech & magazine journalism
  'theverge.com',
  'wired.com',
  'arstechnica.com',
  'technologyreview.com',
  'newscientist.com',
  'nationalgeographic.com',
  'scientificamerican.com',

  // Scientific & academic journals
  'nature.com',
  'science.org',
  'sciencedirect.com',
  'thelancet.com',
  'nejm.org',
  'pnas.org',
  'cell.com',
  'bmj.com',
  'plos.org',
  'arxiv.org',
  'springer.com',
  'wiley.com',

  // Government / institutional
  'who.int',
  'cdc.gov',
  'nih.gov',
  'nasa.gov',
  'noaa.gov',
  'europa.eu',
  'un.org',
  // ── Expanded trustworthy news / press / broadcasters / fact-checkers / agencies / institutions ──
  'cnn.com', 'edition.cnn.com', 'channelnewsasia.com', 'cnbc.com', 'nbcnews.com',
  'cbsnews.com', 'abcnews.go.com', 'foxnews.com', 'news.sky.com', 'euronews.com',
  'france24.com', 'rte.ie', 'irishtimes.com', 'independent.co.uk', 'telegraph.co.uk',
  'thetimes.co.uk', 'thehill.com', 'politico.com', 'politico.eu', 'axios.com',
  'vox.com', 'businessinsider.com', 'forbes.com', 'fortune.com', 'time.com',
  'newsweek.com', 'marketwatch.com', 'barrons.com', 'propublica.org', 'theconversation.com',
  'afp.com', 'upi.com', 'theintercept.com', 'thehindu.com', 'timesofindia.indiatimes.com',
  'indianexpress.com', 'hindustantimes.com', 'ndtv.com', 'livemint.com', 'scmp.com',
  'straitstimes.com', 'japantimes.co.jp', 'asahi.com', 'koreaherald.com', 'bangkokpost.com',
  'jakartapost.com', 'dawn.com', 'arabnews.com', 'gulfnews.com', 'thenationalnews.com',
  'haaretz.com', 'timesofisrael.com', 'jpost.com', 'lemonde.fr', 'lefigaro.fr',
  'spiegel.de', 'faz.net', 'sueddeutsche.de', 'zeit.de', 'elpais.com',
  'elmundo.es', 'corriere.it', 'repubblica.it', 'ansa.it', 'folha.uol.com.br',
  'lanacion.com.ar', 'theglobeandmail.com', 'nationalpost.com', 'thestar.com', 'ctvnews.ca',
  'globalnews.ca', 'nzherald.co.nz', 'stuff.co.nz', 'theage.com.au', 'news.com.au',
  'sbs.com.au', 'voanews.com', 'rferl.org', 'snopes.com', 'politifact.com',
  'factcheck.org', 'fullfact.org', 'leadstories.com', 'cnet.com', 'zdnet.com',
  'techcrunch.com', 'engadget.com', 'theregister.com', 'quantamagazine.org', 'sciencenews.org',
  'smithsonianmag.com', 'statnews.com', 'gov.uk', 'whitehouse.gov', 'state.gov',
  'imf.org', 'worldbank.org', 'oecd.org', 'nato.int', 'fda.gov',
  'unesco.org', 'unicef.org',

];

const stripWww = (host) => host.replace(/^www\./, '');

/**
 * Parse a URL string and return a normalized lowercase hostname.
 * Returns null if the URL is invalid or empty.
 */
export const parseDomain = (sourceUrl) => {
  if (!sourceUrl || typeof sourceUrl !== 'string') return null;
  const trimmed = sourceUrl.trim();
  if (!trimmed) return null;

  let candidate = trimmed;
  if (!/^https?:\/\//i.test(candidate)) {
    candidate = 'https://' + candidate;
  }

  try {
    const u = new URL(candidate);
    return stripWww(u.hostname.toLowerCase());
  } catch {
    return null;
  }
};

/**
 * Returns true if the supplied URL (or domain) is on the trusted whitelist.
 * Matches both the exact domain and any subdomain.
 */
export const isTrustedSource = (sourceUrl) => {
  const host = parseDomain(sourceUrl);
  if (!host) return false;
  return TRUSTED_NEWS_DOMAINS.some(
    (d) => host === d || host.endsWith('.' + d)
  );
};

export default {
  TRUSTED_NEWS_DOMAINS,
  isTrustedSource,
  parseDomain,
};
